export enum ChartType {
    None = 'None',
    Horizontal = 'Horizontal',
}
